import React from 'react';
import Col from 'react-bootstrap/Col';
import {Row} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Slide from 'react-reveal/Slide';
import './Services.css';


function Services() {
    return (
    <div id="services" className='services align-items-center justify-content-space-between d-flex flex-column'>
        <Container>
            
            <Row>
                <Slide bottom>
                    <h6 className='services__header__small'>Royal Smiles Dental Clinic GreenSpan</h6>
                    <h2 className='services__header'>Our Dental Services</h2>
                </Slide>

                
                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/root-canal.jpg)`}}>
                            <div className='services__content__mask'>
                                <h5>Root Canal</h5>
                            </div>
                        

                        </div>
                    </Col>
            

                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/examination.jpg)`}}>
                            <div className='services__content__mask'>
                                <h5 >Dental Examination</h5>
                            </div>

                        </div>
                    </Col>
                

                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/cosmetic.jpg)`}}>
                            <div className='services__content__mask'>
                                    <h5>Cosmetic Dentistry</h5>
                            </div>

                        </div>
                    </Col>

                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/braces.jpg)`}}>
                        <div className='services__content__mask'>
                                <h5>Braces</h5>
                            </div>

                        </div>
                    </Col>
                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/crown.jpg)`}}>
                            <div className='services__content__mask'>
                                <h5>Crowns</h5>
                            </div>

                        </div>
                    </Col>

                    <Col  sm={12} lg={4} md={6} className="my-3" style={{height:'200px'}} >
                        <div className="services__content" style={{backgroundImage:`url(/images/x-ray.jpg)`}}>
                            <div className='services__content__mask'>
                                <h5>X-Rays & Cleanings</h5>
                            </div>

                        </div>
                    </Col>
                


            </Row>

        

        </Container>
    </div>
    );
}

export default Services;
